import {getEndpoint, getHeaders} from '../../helpers/endpoint';

export const REQUEST_GET_DAILY_REPORT_ACQUISITION =
  'REQUEST_GET_DAILY_REPORT_ACQUISITION';
export const SUCCESS_GET_DAILY_REPORT_ACQUISITION =
  'SUCCESS_GET_DAILY_REPORT_ACQUISITION';
export const FAIL_GET_DAILY_REPORT_ACQUISITION =
  'FAIL_GET_DAILY_REPORT_ACQUISITION';

export const getDailyReportAcquisition = (refresh, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_DAILY_REPORT_ACQUISITION});

    return fetch(getEndpoint('getDailyReportAcquisition', refresh), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_DAILY_REPORT_ACQUISITION,
            error: data.error,
          });
        } else dispatch(successGetDailyReportAcquisition(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_DAILY_REPORT_ACQUISITION) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetDailyReportAcquisition(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_DAILY_REPORT_ACQUISITION,
      response,
    });
  };
}

export const REQUEST_GET_DAILY_REPORT_LOYALTY =
  'REQUEST_GET_DAILY_REPORT_LOYALTY';
export const SUCCESS_GET_DAILY_REPORT_LOYALTY =
  'SUCCESS_GET_DAILY_REPORT_LOYALTY';
export const FAIL_GET_DAILY_REPORT_LOYALTY = 'FAIL_GET_DAILY_REPORT_LOYALTY';

export const getDailyReportLoyalty = (refresh, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_DAILY_REPORT_LOYALTY});

    return fetch(getEndpoint('getDailyReportLoyalty', refresh), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_DAILY_REPORT_LOYALTY,
            error: data.error,
          });
        } else dispatch(successGetDailyReportLoyalty(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_DAILY_REPORT_LOYALTY) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetDailyReportLoyalty(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_DAILY_REPORT_LOYALTY,
      response,
    });
  };
}

export const REQUEST_GET_DAILY_REPORT_FREEMIUM =
  'REQUEST_GET_DAILY_REPORT_FREEMIUM';
export const SUCCESS_GET_DAILY_REPORT_FREEMIUM =
  'SUCCESS_GET_DAILY_REPORT_FREEMIUM';
export const FAIL_GET_DAILY_REPORT_FREEMIUM = 'FAIL_GET_DAILY_REPORT_FREEMIUM';

export const getDailyReportFreemium = (refresh, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_DAILY_REPORT_FREEMIUM});

    return fetch(getEndpoint('getDailyReportFreemium', refresh), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_DAILY_REPORT_FREEMIUM,
            error: data.error,
          });
        } else dispatch(successGetDailyReportFreemium(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_DAILY_REPORT_FREEMIUM) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetDailyReportFreemium(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_DAILY_REPORT_FREEMIUM,
      response,
    });
  };
}

export const REQUEST_USERS_RETENTION = 'REQUEST_USERS_RETENTION';
export const SUCCESS_USERS_RETENTION = 'SUCCESS_USERS_RETENTION';
export const FAIL_USERS_RETENTION = 'FAIL_USERS_RETENTION';

export const getUsersRetention = (onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_USERS_RETENTION});

    return fetch(getEndpoint('getUsersRetention'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_USERS_RETENTION,
            error: data.error,
          });
        } else dispatch(successGetUsersRetention(data, onSuccess));
      })
      .catch((error, type = FAIL_USERS_RETENTION) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetUsersRetention(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_USERS_RETENTION,
      data: response,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities/dailyReport.js